const { makeStyles } = require("@material-ui/core");

export const AssetSearchBarStyles = makeStyles((theme) => ({
    autoComplete: {
        margin: '0.5rem 0 ',
        padding: '0.5rem 0 0.5rem 0.5rem',
        color: theme.palette.common.darkText,
        border: '1px solid lightGrey',
        borderRadius: '4px',

        '&.MuiOutlinedInput-adornedEnd': {
            backgroundColor: theme.palette.background.default,
        },
        '&.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: '0 !important',
        },
        '&.MuiAutocomplete-inputRoot': {
            padding: '0 !important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '& fieldset': {
            border: 'none'
        }
    },
    itemLabel: {
        fontWeight: 600,
    },
    itemIcon: {
        paddingRight: '1em',
    },
}));